export const ALL_SEASONS = {
    label: 'All Seasons',
    value: ''
};
